import React, { createContext, useContext, useState, useEffect } from 'react';

export interface User {
  username: string;
  id: string;
  email: string;
  role: string;
  
}

interface AuthContextType {
  currentUser: User | null;
  token: string | null; // ✅ ADD THIS
  loading: boolean;
  login: (userData: User, token: string, refreshToken: string) => void;
  logout: () => void;
}

const defaultAuthContext: AuthContextType = {
  currentUser: null,
  token: null, // ✅ ADD
  login: () => {},
  logout: () => {},
  loading: true,
};

const AuthContext = createContext<AuthContextType>(defaultAuthContext);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);

useEffect(() => {
  try {
    const storedUser = localStorage.getItem('currentUser');
    const storedToken = localStorage.getItem('token');

    if (storedUser && storedToken) {
      const parsedUser = JSON.parse(storedUser);

      setCurrentUser(parsedUser);
      setToken(storedToken); // ✅ ADD THIS

      setLoading(false);
      return;
    }
  } catch (error) {
    console.error('Failed to parse user:', error);
  }

  setLoading(false);
}, []);

  const login = (userData: User, token: string, refreshToken: string) => {
  setCurrentUser(userData);
  setToken(token); // ✅ IMPORTANT

  localStorage.setItem('currentUser', JSON.stringify(userData));
  localStorage.setItem('token', token);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('auth', 'true');
};

  const logout = () => {
  setCurrentUser(null);
  setToken(null); // ✅ IMPORTANT

  localStorage.removeItem('currentUser');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('auth');
};

  return (
   <AuthContext.Provider value={{ currentUser, login, logout, loading,token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
